function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.90019 6.99983C6.44681 6.99983 7.7003 5.43307 7.7003 3.49992C7.7003 1.56676 6.44681 0 4.90019 0C3.35357 0 2.10008 1.56676 2.10008 3.49992C2.10008 5.43307 3.35357 6.99983 4.90019 6.99983ZM6.86027 7.87481H6.49494C6.0093 8.15371 5.46896 8.3123 4.90019 8.3123C4.33142 8.3123 3.79327 8.15371 3.30544 7.87481H2.94011C1.31693 7.87481 0 9.52087 0 11.5497V12.6872C0 13.4118 0.470331 13.9997 1.05004 13.9997H7.06371C7.01121 13.8137 6.98934 13.6169 7.00684 13.4173L7.15559 11.7521L7.18184 11.4486L7.35466 11.2325L9.04567 9.11892C8.50971 8.36152 7.73311 7.87481 6.86027 7.87481ZM7.85124 11.8478L7.70249 13.5157C7.67843 13.7946 7.86656 14.0297 8.0875 13.9969L9.41974 13.811L12.4364 10.0404L10.8679 8.07989L7.85124 11.8478ZM13.8474 7.35256L13.0183 6.31626C12.8149 6.06197 12.4824 6.06197 12.2789 6.31626L11.452 7.34983L11.3623 7.46193L12.933 9.42243L13.8474 8.27949C14.0509 8.02247 14.0509 7.60959 13.8474 7.35256Z",
  fill: "black"
});

function SvgUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.355aeb4b.svg";
export { ForwardRef as ReactComponent };